/**
 * Created by or_p on 7/19/2016.
 */

let notificationSystem;
import * as Colors from 'material-ui/styles/colors';

function ref(ref) {
  if (ref) {
    notificationSystem = ref;
  }
}

export function addNotification(notification) {
  notificationSystem.addNotification(notification);
}

export const style = {
  Containers: {
    DefaultStyle: {
      transform: 'translateY(40px)',
      width: 'auto',
    }
  },
  NotificationItem: {
    DefaultStyle: {
      borderTopWidth: 0,
      borderWidth: 0,
      borderRadius: 0,
      boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
      fontSize: 16,
      fontFamily: 'Roboto',
      padding: 20,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    success: {
      backgroundColor: Colors.lightGreen50,
      color: Colors.lightGreen800,
    },
    error: {
      backgroundColor: Colors.red50,
      color: Colors.red700,
    }
  },
  Dismiss: {
    DefaultStyle: {
      fontFamily: 'Material Icon',
      height: 'auto',
      width: 'auto',
      top: 0,
      right: 0,
      position: 'relative',
      fontSize: 32,
      marginLeft: 20,
    },
    success: {
      backgroundColor: 'none',
      color: Colors.lightGreen800,
    },
    error: {
      backgroundColor: 'none',
      color: Colors.red700,
    }
  }
};

export const notificationSystemProps = {
  allowHTML: true,
  ref,
  style,
};
